// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const FieldType = {
    FIELD_TYPE_INVALID: 'FIELD_TYPE_INVALID',
    FIELD_TYPE_STRING: 'FIELD_TYPE_STRING',
    FIELD_TYPE_INTEGER: 'FIELD_TYPE_INTEGER',
    FIELD_TYPE_DATE: 'FIELD_TYPE_DATE',
    FIELD_TYPE_DROPDOWN: 'FIELD_TYPE_DROPDOWN',
    FIELD_TYPE_CURRENCY: 'FIELD_TYPE_CURRENCY',
    FIELD_TYPE_EMAIL: 'FIELD_TYPE_EMAIL',
    FIELD_TYPE_PHONE: 'FIELD_TYPE_PHONE',
    FIELD_TYPE_BOOLEAN: 'FIELD_TYPE_BOOLEAN',
    FIELD_TYPE_TAG: 'FIELD_TYPE_TAG',
    FIELD_TYPE_DATETIME: 'FIELD_TYPE_DATETIME',
    FIELD_TYPE_STRING_LIST: 'FIELD_TYPE_STRING_LIST',
    FIELD_TYPE_GEOPOINT: 'FIELD_TYPE_GEOPOINT',
    FIELD_TYPE_FLOAT: 'FIELD_TYPE_FLOAT',
    FIELD_TYPE_TIMER: 'FIELD_TYPE_TIMER',
};
export const FieldTypeValue = {
    FIELD_TYPE_INVALID: 0,
    FIELD_TYPE_STRING: 1,
    FIELD_TYPE_INTEGER: 2,
    FIELD_TYPE_DATE: 3,
    FIELD_TYPE_DROPDOWN: 4,
    FIELD_TYPE_CURRENCY: 5,
    FIELD_TYPE_EMAIL: 6,
    FIELD_TYPE_PHONE: 7,
    FIELD_TYPE_BOOLEAN: 8,
    FIELD_TYPE_TAG: 9,
    FIELD_TYPE_DATETIME: 10,
    FIELD_TYPE_STRING_LIST: 11,
    FIELD_TYPE_GEOPOINT: 12,
    FIELD_TYPE_FLOAT: 13,
    FIELD_TYPE_TIMER: 14,
};
export const FieldUniqueness = {
    FIELD_UNIQUENESS_NONE: 'FIELD_UNIQUENESS_NONE',
    FIELD_UNIQUENESS_WARNING: 'FIELD_UNIQUENESS_WARNING',
    FIELD_UNIQUENESS_ENFORCED: 'FIELD_UNIQUENESS_ENFORCED',
};
export const FieldUniquenessValue = {
    FIELD_UNIQUENESS_NONE: 0,
    FIELD_UNIQUENESS_WARNING: 1,
    FIELD_UNIQUENESS_ENFORCED: 2,
};
export const ProjectionFilterType = {
    PROJECTION_FILTER_TYPE_INVALID: 'PROJECTION_FILTER_TYPE_INVALID',
    PROJECTION_FILTER_TYPE_FIELD_TYPE: 'PROJECTION_FILTER_TYPE_FIELD_TYPE',
    PROJECTION_FILTER_TYPE_INCLUDE_DELETED: 'PROJECTION_FILTER_TYPE_INCLUDE_DELETED',
};
export const ProjectionFilterTypeValue = {
    PROJECTION_FILTER_TYPE_INVALID: 0,
    PROJECTION_FILTER_TYPE_FIELD_TYPE: 1,
    PROJECTION_FILTER_TYPE_INCLUDE_DELETED: 2,
};
export const TimerStatus = {
    TIMER_STATUS_INVALID: 'TIMER_STATUS_INVALID',
    TIMER_STATUS_INACTIVE: 'TIMER_STATUS_INACTIVE',
    TIMER_STATUS_ACTIVE: 'TIMER_STATUS_ACTIVE',
    TIMER_STATUS_PAUSED: 'TIMER_STATUS_PAUSED',
    TIMER_STATUS_EXPIRED: 'TIMER_STATUS_EXPIRED',
    TIMER_STATUS_STOPPED: 'TIMER_STATUS_STOPPED',
    TIMER_STATUS_TERMINATED: 'TIMER_STATUS_TERMINATED',
};
export const TimerStatusValue = {
    TIMER_STATUS_INVALID: 0,
    TIMER_STATUS_INACTIVE: 1,
    TIMER_STATUS_ACTIVE: 2,
    TIMER_STATUS_PAUSED: 3,
    TIMER_STATUS_EXPIRED: 4,
    TIMER_STATUS_STOPPED: 5,
    TIMER_STATUS_TERMINATED: 6,
};
export const SortDirection = {
    SORT_DIRECTION_INVALID: 'SORT_DIRECTION_INVALID',
    SORT_DIRECTION_ASCENDING: 'SORT_DIRECTION_ASCENDING',
    SORT_DIRECTION_DESCENDING: 'SORT_DIRECTION_DESCENDING',
};
export const SortDirectionValue = {
    SORT_DIRECTION_INVALID: 0,
    SORT_DIRECTION_ASCENDING: 1,
    SORT_DIRECTION_DESCENDING: 2,
};
export const ValidateCrmObjectResponseFieldUniqueness = {
    FIELD_UNIQUENESS_INVALID: 'FIELD_UNIQUENESS_INVALID',
    FIELD_UNIQUENESS_NONE: 'FIELD_UNIQUENESS_NONE',
    FIELD_UNIQUENESS_WARNING: 'FIELD_UNIQUENESS_WARNING',
    FIELD_UNIQUENESS_ENFORCED: 'FIELD_UNIQUENESS_ENFORCED',
};
export const ValidateCrmObjectResponseFieldUniquenessValue = {
    FIELD_UNIQUENESS_INVALID: 0,
    FIELD_UNIQUENESS_NONE: 1,
    FIELD_UNIQUENESS_WARNING: 2,
    FIELD_UNIQUENESS_ENFORCED: 3,
};
export const ValidateCrmObjectResponseValidationErrorSeverity = {
    VALIDATION_ERROR_SEVERITY_UNKNOWN: 'VALIDATION_ERROR_SEVERITY_UNKNOWN',
    VALIDATION_ERROR_SEVERITY_INVALID: 'VALIDATION_ERROR_SEVERITY_INVALID',
    VALIDATION_ERROR_SEVERITY_WARNING: 'VALIDATION_ERROR_SEVERITY_WARNING',
};
export const ValidateCrmObjectResponseValidationErrorSeverityValue = {
    VALIDATION_ERROR_SEVERITY_UNKNOWN: 0,
    VALIDATION_ERROR_SEVERITY_INVALID: 1,
    VALIDATION_ERROR_SEVERITY_WARNING: 2,
};
export const MetricType = {
    METRIC_TYPE_INVALID: 'METRIC_TYPE_INVALID',
    METRIC_TYPE_OUTBOUND_CALLS: 'METRIC_TYPE_OUTBOUND_CALLS',
    METRIC_TYPE_INBOUND_CALLS: 'METRIC_TYPE_INBOUND_CALLS',
    METRIC_TYPE_EMAILS_SENT: 'METRIC_TYPE_EMAILS_SENT',
    METRIC_TYPE_EMAILS_RECEIVED: 'METRIC_TYPE_EMAILS_RECEIVED',
    METRIC_TYPE_MEETINGS: 'METRIC_TYPE_MEETINGS',
};
export const MetricTypeValue = {
    METRIC_TYPE_INVALID: 0,
    METRIC_TYPE_OUTBOUND_CALLS: 1,
    METRIC_TYPE_INBOUND_CALLS: 2,
    METRIC_TYPE_EMAILS_SENT: 3,
    METRIC_TYPE_EMAILS_RECEIVED: 4,
    METRIC_TYPE_MEETINGS: 5,
};
export const DuplicateHandlingType = {
    DUPLICATE_HANDLING_TYPE_INVALID: 'DUPLICATE_HANDLING_TYPE_INVALID',
    DUPLICATE_HANDLING_TYPE_SKIP: 'DUPLICATE_HANDLING_TYPE_SKIP',
    DUPLICATE_HANDLING_TYPE_UPDATE: 'DUPLICATE_HANDLING_TYPE_UPDATE',
};
export const DuplicateHandlingTypeValue = {
    DUPLICATE_HANDLING_TYPE_INVALID: 0,
    DUPLICATE_HANDLING_TYPE_SKIP: 1,
    DUPLICATE_HANDLING_TYPE_UPDATE: 2,
};
export const ImportRecordStatus = {
    IMPORT_RECORD_STATUS_STARTED: 'IMPORT_RECORD_STATUS_STARTED',
    IMPORT_RECORD_STATUS_COMPLETED: 'IMPORT_RECORD_STATUS_COMPLETED',
    IMPORT_RECORD_STATUS_ERROR: 'IMPORT_RECORD_STATUS_ERROR',
};
export const ImportRecordStatusValue = {
    IMPORT_RECORD_STATUS_STARTED: 0,
    IMPORT_RECORD_STATUS_COMPLETED: 1,
    IMPORT_RECORD_STATUS_ERROR: 2,
};
export const App = {
    APP_UNSPECIFIED: 'APP_UNSPECIFIED',
    APP_BUSINESS_CENTER_CLIENT: 'APP_BUSINESS_CENTER_CLIENT',
    APP_PARTNER_CENTER_CLIENT: 'APP_PARTNER_CENTER_CLIENT',
};
export const AppValue = {
    APP_UNSPECIFIED: 0,
    APP_BUSINESS_CENTER_CLIENT: 1,
    APP_PARTNER_CENTER_CLIENT: 2,
};
export const Context = {
    CONTEXT_UNSPECIFIED: 'CONTEXT_UNSPECIFIED',
    CONTEXT_ACTIVITY_FEED: 'CONTEXT_ACTIVITY_FEED',
    CONTEXT_TABLE: 'CONTEXT_TABLE',
};
export const ContextValue = {
    CONTEXT_UNSPECIFIED: 0,
    CONTEXT_ACTIVITY_FEED: 1,
    CONTEXT_TABLE: 2,
};
export const JoinDirection = {
    JOIN_DIRECTION_UNSPECIFIED: 'JOIN_DIRECTION_UNSPECIFIED',
    JOIN_DIRECTION_FROM_TO: 'JOIN_DIRECTION_FROM_TO',
    JOIN_DIRECTION_TO_FROM: 'JOIN_DIRECTION_TO_FROM',
};
export const JoinDirectionValue = {
    JOIN_DIRECTION_UNSPECIFIED: 0,
    JOIN_DIRECTION_FROM_TO: 1,
    JOIN_DIRECTION_TO_FROM: 2,
};
export const JoinType = {
    JOIN_TYPE_UNSPECIFIED: 'JOIN_TYPE_UNSPECIFIED',
    JOIN_TYPE_INNER: 'JOIN_TYPE_INNER',
    JOIN_TYPE_LEFT: 'JOIN_TYPE_LEFT',
};
export const JoinTypeValue = {
    JOIN_TYPE_UNSPECIFIED: 0,
    JOIN_TYPE_INNER: 1,
    JOIN_TYPE_LEFT: 2,
};
export const QueryTier = {
    QUERY_TIER_UNSPECIFIED: 'QUERY_TIER_UNSPECIFIED',
    QUERY_TIER_1: 'QUERY_TIER_1',
    QUERY_TIER_2: 'QUERY_TIER_2',
};
export const QueryTierValue = {
    QUERY_TIER_UNSPECIFIED: 0,
    QUERY_TIER_1: 1,
    QUERY_TIER_2: 2,
};
export const AggregationOp = {
    AGGREGATION_OP_UNSPECIFIED: 'AGGREGATION_OP_UNSPECIFIED',
    AGGREGATION_OP_COUNT: 'AGGREGATION_OP_COUNT',
    AGGREGATION_OP_SUM: 'AGGREGATION_OP_SUM',
    AGGREGATION_OP_AVG: 'AGGREGATION_OP_AVG',
    AGGREGATION_OP_MIN: 'AGGREGATION_OP_MIN',
    AGGREGATION_OP_MAX: 'AGGREGATION_OP_MAX',
};
export const AggregationOpValue = {
    AGGREGATION_OP_UNSPECIFIED: 0,
    AGGREGATION_OP_COUNT: 1,
    AGGREGATION_OP_SUM: 2,
    AGGREGATION_OP_AVG: 3,
    AGGREGATION_OP_MIN: 4,
    AGGREGATION_OP_MAX: 5,
};
export const CrmObjectMutationOp = {
    CRM_OBJECT_MUTATION_OP_INVALID: 'CRM_OBJECT_MUTATION_OP_INVALID',
    CRM_OBJECT_MUTATION_OP_CREATE: 'CRM_OBJECT_MUTATION_OP_CREATE',
    CRM_OBJECT_MUTATION_OP_UPDATE: 'CRM_OBJECT_MUTATION_OP_UPDATE',
    CRM_OBJECT_MUTATION_OP_UPSERT: 'CRM_OBJECT_MUTATION_OP_UPSERT',
    CRM_OBJECT_MUTATION_OP_DELETE: 'CRM_OBJECT_MUTATION_OP_DELETE',
};
export const CrmObjectMutationOpValue = {
    CRM_OBJECT_MUTATION_OP_INVALID: 0,
    CRM_OBJECT_MUTATION_OP_CREATE: 1,
    CRM_OBJECT_MUTATION_OP_UPDATE: 2,
    CRM_OBJECT_MUTATION_OP_UPSERT: 3,
    CRM_OBJECT_MUTATION_OP_DELETE: 4,
};
export const AssociationMutationOp = {
    ASSOCIATION_MUTATION_OP_INVALID: 'ASSOCIATION_MUTATION_OP_INVALID',
    ASSOCIATION_MUTATION_OP_CREATE: 'ASSOCIATION_MUTATION_OP_CREATE',
    ASSOCIATION_MUTATION_OP_DELETE: 'ASSOCIATION_MUTATION_OP_DELETE',
};
export const AssociationMutationOpValue = {
    ASSOCIATION_MUTATION_OP_INVALID: 0,
    ASSOCIATION_MUTATION_OP_CREATE: 1,
    ASSOCIATION_MUTATION_OP_DELETE: 2,
};
export const FieldSchemaOpType = {
    FIELD_SCHEMA_OP_TYPE_INVALID: 'FIELD_SCHEMA_OP_TYPE_INVALID',
    FIELD_SCHEMA_OP_TYPE_ADD: 'FIELD_SCHEMA_OP_TYPE_ADD',
    FIELD_SCHEMA_OP_TYPE_MODIFY: 'FIELD_SCHEMA_OP_TYPE_MODIFY',
    FIELD_SCHEMA_OP_TYPE_ARCHIVE: 'FIELD_SCHEMA_OP_TYPE_ARCHIVE',
};
export const FieldSchemaOpTypeValue = {
    FIELD_SCHEMA_OP_TYPE_INVALID: 0,
    FIELD_SCHEMA_OP_TYPE_ADD: 1,
    FIELD_SCHEMA_OP_TYPE_MODIFY: 2,
    FIELD_SCHEMA_OP_TYPE_ARCHIVE: 3,
};
